/* eslint-disable no-undef */
/* eslint-disable no-empty */
/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
export let state = {
  currentUser: localStorage.getItem("currentUser") || false,
  tabs:
    (localStorage.getItem("posTab") &&
      JSON.parse(localStorage.getItem("posTab"))) ||
    [],
  currentTab: 0,
  nextTab: 1,
  sessionID:
    (localStorage.getItem("sessionID") &&
      parseInt(localStorage.getItem("sessionID"))) ||
    0,
  posID:
    (localStorage.getItem("posID") &&
      JSON.parse(localStorage.getItem("posID"))) ||
    false,
  cashier: [],
  provinceList:
    (localStorage.getItem("provinceList") &&
      JSON.parse(localStorage.getItem("provinceList"))) ||
    [],
  districtList:
    (localStorage.getItem("districtList") &&
      JSON.parse(localStorage.getItem("districtList"))) ||
    [],
  paymentMethodList: [],
  productSelected: { id: 0, cost: 0, discount: 0, serials: [] },
  noti: [],
};

function calcSubAmount(data) {
  let total = 0;
  for (const item of data.products) {
    total =
      total + (item.cost - (item.discount * item.cost) / 100) * item.amount;
  }
  return Math.round(total);
}

function calcVoucherDiscount(data, _temp = 0) {
  console.log('_temp total = ' + _temp);
  let voucher = data.info.voucher;
  if ( typeof voucher == "undefined" || typeof voucher.is_percent == "undefined" || typeof voucher.value == "undefined" || typeof voucher.apply_for == "undefined" || typeof voucher.list_product == "undefined" || typeof voucher.list_category == "undefined") {
    return 0;
  }
  console.log('_temp voucher', voucher);

  if (voucher.is_percent) {
    var totalDiscount = 0;
    if(voucher.value > 100) voucher.value = 100;
    for (const item of data.products) {
      if ( voucher.apply_for == "all_orders" || (voucher.apply_for == "product_category" && voucher.list_category.indexOf(item._data.cate_id) >= 0) || (voucher.apply_for == "product" && voucher.list_product.indexOf(item.id) >= 0)) {
        totalDiscount += (item.cost - (item.discount * item.cost) / 100) * item.amount;
      }
    }
    totalDiscount = totalDiscount * (voucher.value / 100);
    return Math.round(totalDiscount);
  }
  return voucher.value > _temp ? _temp : voucher.value;
}

function calcTotalAmount(data) {
  // -- Quy trình giảm giá khuyến mãi trên đơn như sau 17/10/2023 - 18/10/2023 A.Dâu confirm
  // -- 1. Giảm từng sản phẩm => giá X
  // -- 2. Giảm khác tổng hoá đơn => trừ trên giá X => giá Y
  // -- 3. Giảm voucher:
  // --   TH 1: giảm trên đơn => trừ trên giá Y
  // --   TH 2: giảm trên từng sản phẩm => thì phải lấy gía từng sản phẩm thoả điều kiện theo giá đã giảm bước 1, rồi trừ tiếp theo giá trị Voucher
  // -- 4. Giảm thành viên
  // -- 5. Cộng vào phí ship
  // -- Ghi chú: Đã đặt câu hỏi tại hời điêm này sao phân biêt được loại voucher trên đơn or từng sản phẩm
  // -- Confirm: bỏ qua logic voucher mới, bỏ qua cái logic code cũ hiện tại, chỉ cần fix code chạy được các vocher cũ là được.A.Kiên said 16:45 18/10/2023

  // -- Bước 1. giảm giá từng sản phẩm
  let subAmount = calcSubAmount(data);

  // -- Bước 2. Giảm khác tổng hoá đơn
  let _v = subAmount - data.info.otherDiscount;

  // -- Bước 3. Giảm voucher
  let voucherDiscount = calcVoucherDiscount(data, _v);
  _v = _v - voucherDiscount;

  // -- Bước 4. Giảm thành viên
  let customerDiscount =
    typeof data.info.customer != "undefined" &&
    typeof data.info.customer.member_percent != "undefined"
      ? data.info.customer.member_percent
      : 0;
  _v = _v - (_v * customerDiscount) / 100;

  // -- Bước 5. Công phí ship vào
  let transportFee =
    typeof data.info.transportFee != "undefined"
      ? parseInt(data.info.transportFee)
      : 0;
  _v = _v + transportFee;

  return Math.round(_v < 0 ? 0 : _v);
}

function calcTotalAmountGross(data) {
  // -- Quy trình giảm giá khuyến mãi trên đơn như sau 17/10/2023 - 18/10/2023 A.Dâu confirm
  // -- 1. Giảm từng sản phẩm => giá X
  // -- 2. Giảm khác tổng hoá đơn => trừ trên giá X => giá Y
  // -- 3. Giảm voucher:
  // --   TH 1: giảm trên đơn => trừ trên giá Y
  // --   TH 2: giảm trên từng sản phẩm => thì phải lấy gía từng sản phẩm thoả điều kiện theo giá đã giảm bước 1, rồi trừ tiếp theo giá trị Voucher
  // -- 4. Giảm thành viên
  // -- 5. Cộng vào phí ship
  // -- Ghi chú: Đã đặt câu hỏi tại hời điêm này sao phân biêt được loại voucher trên đơn or từng sản phẩm
  // -- Confirm: bỏ qua logic voucher mới, bỏ qua cái logic code cũ hiện tại, chỉ cần fix code chạy được các vocher cũ là được.A.Kiên said 16:45 18/10/2023

  // -- Bước 1. giảm giá từng sản phẩm
  let subAmount = calcSubAmount(data);

  // -- Bước 2. Giảm khác tổng hoá đơn
  let _v = subAmount - data.info.otherDiscount;

  // -- Bước 3. Giảm voucher
  let voucherDiscount = calcVoucherDiscount(data, _v);
  _v = _v - voucherDiscount;

  // -- Bước 4. Giảm thành viên
  let customerDiscount =
    typeof data.info.customer != "undefined" &&
    typeof data.info.customer.member_percent != "undefined"
      ? data.info.customer.member_percent
      : 0;
  _v = _v - (_v * customerDiscount) / 100;

  // -- Bước 5. Công phí ship vào
  let transportFee =
    typeof data.info.transportFee != "undefined"
      ? parseInt(data.info.transportFee)
      : 0;
  _v = _v + transportFee;

  return Math.round(_v);
}

function calcTotalPayment(data) {
  let payment =
    typeof data.info != "undefined" && typeof data.info.payment != "undefined"
      ? data.info.payment
      : [];
  var totalPayment = 0;
  for (var p of payment) {
    totalPayment = totalPayment + p.value * 1;
  }
  return Math.round(totalPayment);
}

function calcCustomerDiscountValue(data) {
  let subAmount = calcSubAmount(data);
  let _v = subAmount - data.info.otherDiscount;
  let voucherDiscount = calcVoucherDiscount(data, _v);
  let customerDiscount =
    typeof data.info.customer != "undefined" &&
    typeof data.info.customer.member_percent != "undefined"
      ? data.info.customer.member_percent
      : 0;
  var sub = subAmount - data.info.otherDiscount - voucherDiscount;
  return Math.round((sub * customerDiscount) / 100);
}

function calcReturnAmount(data) {
  let totalAmount = calcTotalAmount(data);
  let totalPayment = calcTotalPayment(data);
  return Math.round(totalPayment - totalAmount);
}

function calcTotalDiscount(data) {
  let transportFee =
    typeof data.info.transportFee != "undefined"
      ? parseInt(data.info.transportFee)
      : 0;
  let subAmount = calcSubAmount(data);
  // subAmount = subAmount + transportFee;
  let totalAmout = calcTotalAmount(data) - transportFee;

  return Math.round(subAmount - totalAmout);
}

function recalcData(state) {
  state.tabs = state.tabs.filter(function(tab) {
    if (tab.id == state.currentTab) {
      tab.info.subAmount = calcSubAmount(tab);
      tab.info.customerDiscount = typeof tab.info.customer != "undefined" && typeof tab.info.customer.member_percent != "undefined" ? tab.info.customer.member_percent : 0;
      let _v = tab.info.subAmount - tab.info.otherDiscount;
      tab.info.customerDiscountValue = calcCustomerDiscountValue(tab);
      tab.info.voucherDiscount = calcVoucherDiscount(tab, _v);
      tab.info.totalAmount = calcTotalAmount(tab);
      tab.info.totalAmountGross = calcTotalAmountGross(tab);
      tab.info.returnAmount = calcReturnAmount(tab);
      tab.info.totalDiscount = calcTotalDiscount(tab);
    }
    return tab;
  });
  localStorage.setItem("posTab", JSON.stringify(state.tabs));
}
let newTabDefine = {
  id: 0,
  products: [],
  ebill: [],
  search: "",
  info: {
    subAmount: 0,
    otherDiscount: 0,
    otherDiscountNote: "",
    customerDiscount: 0,
    customerDiscountValue: 0,
    voucherDiscount: 0,
    transportFee: 0,
    totalAmount: 0,
    totalAmountGross: 0,
    returnAmount: 0,
    voucher: {},
    nvbh: "",
    customer: {},
    payment: [],
    totalDiscount: 0,
  },
  print: false,
  loading: false,
  note: "",
  noteDiscount: "",
  voucher: "",
};
export const mutations = {
  addNewTab(state) {
    let tabs = state.tabs;
    let newTab = JSON.parse(JSON.stringify(newTabDefine));
    newTab.id = state.nextTab;
    tabs.push(newTab);
    state.currentTab = state.nextTab;
    state.nextTab++;
    state.tabs = tabs;
    localStorage.setItem("posTab", JSON.stringify(tabs));
  },
  removeAllTab(state) {
    let newTab = JSON.parse(JSON.stringify(newTabDefine));
    newTab.id = 1;
    state.currentTab = state.nextTab;
    state.nextTab = 2;
    state.tabs = [newTab];
    localStorage.setItem("posTab", JSON.stringify(state.tabs));
  },
  setOrderNote(state, _data) {
    let tab = state.tabs.find((tab) => tab.id == state.currentTab);
    if (typeof tab == "undefined") return false;
    tab.note = _data;
    state.tabs = state.tabs.filter(function(item) {
      return item.id == state.currentTab ? tab : item;
    });
    localStorage.setItem("posTab", JSON.stringify(state.tabs));
  },
  selectFirstTab(state) {
    state.currentTab = state.tabs[0].id;
  },
  setProductSelected(state, _data) {
    state.productSelected = _data;
  },
  activeTab(state, _id) {
    state.currentTab = _id;
  },
  setNextTab(state, _id) {
    state.nextTab = _id + 1;
  },
  removeTab(state, _id) {
    let tabs = state.tabs;
    tabs = tabs.filter((tab) => tab.id != _id);
    state.tabs = tabs;
    localStorage.setItem("posTab", JSON.stringify(tabs));
    state.currentTab = state.tabs[0].id;
  },
  setDistrictProvince(state, _data) {
    state.provinceList = _data.province;
    state.districtList = _data.district;
    localStorage.setItem("provinceList", JSON.stringify(_data.province));
    localStorage.setItem("districtList", JSON.stringify(_data.district));
  },
  setCashier(state, _data) {
    state.cashier = _data;
  },
  setSession(state, _id) {
    state.sessionID = _id;
    localStorage.setItem("sessionID", _id);
  },
  setPosID(state, _id) {
    state.posID = _id;
    localStorage.setItem("posID", JSON.stringify(_id));
  },
  setNoti(state, _data) {
    state.noti.push({
      id: _data.id,
      text: _data.text,
      type: _data.type,
    });
  },
  removeNoti(state, id) {
    state.noti = state.noti.filter((tab) => tab.id != id);
  },
  addProduct(state, data) {
    let tab = state.tabs.find((tab) => tab.id == state.currentTab);
    if (typeof tab == "undefined") return false;
    let pro = {
      id: data.id,
      serials: [data.serial],
      name: data.name,
      cost: data.cost,
      discount: 0,
      amount: 1,
      _data: data,
    };
    if (tab.products.length < 1) {
      tab.products.push(pro);
    } else {
      let has_inarray = false;
      tab.products = tab.products.filter(function(item) {
        if (item.id == pro.id && !has_inarray) {
          has_inarray = true;
          if (!item.serials.includes(data.serial)) {
            item.serials.push(data.serial);
            item.amount++;
          } else {
            throw "Đã thêm sản phẩm trước đó";
          }
        }
        return item;
      });
      if (!has_inarray) {
        tab.products.push(pro);
      }
    }
    state.tabs = state.tabs.filter(function(item) {
      if (item.id == state.currentTab) {
        item.products = tab.products;
      }
      return item;
    });
    recalcData(state);
  },
  removeProduct(state, data) {
    let tab = state.tabs.find((tab) => tab.id == state.currentTab);
    if (typeof tab == "undefined") return false;
    tab.products = tab.products.filter(
      (prod) => prod.serials.join(",") != data.serials.join(",")
    );
    state.tabs = state.tabs.filter(function(item) {
      if (item.id == state.currentTab) {
        item.products = tab.products;
      }
      return item;
    });
    recalcData(state);
  },

  addEbill(state, data) {
    let tab = state.tabs.find((tab) => tab.id == state.currentTab);
    if (typeof tab == "undefined") return false;
    tab.ebill.push({
      name: data.name,
      value: data.value,
      _data: data,
    });
    state.tabs = state.tabs.filter(function(item) {
      if (item.id == state.currentTab) {
        item.ebill = tab.ebill;
      }
      return item;
    });
    recalcData(state);
  },
  removeEbill(state, data) {
    let tab = state.tabs.find((tab) => tab.id == state.currentTab);
    if (typeof tab == "undefined") return false;
    tab.ebill = tab.ebill.filter((prod) => prod.name != data.name);
    state.tabs = state.tabs.filter(function(item) {
      if (item.id == state.currentTab) {
        item.ebill = tab.ebill;
      }
      return item;
    });
    recalcData(state);
  },
  recalcData(state) {
    return recalcData(state);
  },
  removeDiscountCustomer(state) {
    let tab = state.tabs.find((tab) => tab.id == state.currentTab);
    if (typeof tab == "undefined") return false;
    tab.info.customerDiscount = 0;
    tab.info.customerDiscountValue = 0;
    tab.info.customer.member_percent = 0;
    state.tabs = state.tabs.filter(function(item) {
      if (item.id == state.currentTab) {
        item = tab;
      }
      return item;
    });
    return recalcData(state);
  },
  removeDiscountVoucher(state) {
    let tab = state.tabs.find((tab) => tab.id == state.currentTab);
    if (typeof tab == "undefined") return false;
    tab.info.voucher = {};
    state.tabs = state.tabs.filter(function(item) {
      if (item.id == state.currentTab) {
        item = tab;
      }
      return item;
    });
    return recalcData(state);
  },
  setCashierSelected(state, _data) {
    let tab = state.tabs.find((tab) => tab.id == state.currentTab);
    if (typeof tab == "undefined") return false;
    tab.info.nvbh = _data;
    state.tabs = state.tabs.filter(function(item) {
      if (item.id == state.currentTab) {
        item = tab;
      }
      return item;
    });
    return recalcData(state);
  },
  setDiscountOther(state, _data) {
    let tab = state.tabs.find((tab) => tab.id == state.currentTab);
    if (typeof tab == "undefined") return false;
    tab.info.otherDiscount = _data.value > tab.info.totalAmount ? tab.info.totalAmount : _data.value;
    tab.info.otherDiscountNote += tab.info.otherDiscount > 0 ? ` Giảm khác: ${_data.note}` : "";
    state.tabs = state.tabs.filter(function(item) {
      if (item.id == state.currentTab) {
        item = tab;
      }
      return item;
    });
    return recalcData(state);
  },
  resetTab(state) {
    let tab = state.tabs.find((tab) => tab.id == state.currentTab);
    if (typeof tab == "undefined") return false;
    let newTab = JSON.parse(JSON.stringify(newTabDefine));
    newTab.id = tab.id;
    state.tabs = state.tabs.map(function(item) {
      return item.id == state.currentTab ? newTab : item;
    });
    localStorage.setItem("posTab", JSON.stringify(state.tabs));
  },
  setVoucher(state, _data) {
    let tab = state.tabs.find((tab) => tab.id == state.currentTab);
    if (typeof tab == "undefined") return false;
    tab.info.voucher = _data;
    let voucher_code = typeof _data.code != 'undefined' && _data.code != null ? _data.code : '';
    if(voucher_code == '') voucher_code = typeof _data.name != 'undefined' && _data.name != null ? _data.name : '';
    tab.info.otherDiscountNote += ` Voucher Code: ${voucher_code}`;
    state.tabs = state.tabs.filter(function(item) {
      return item.id == state.currentTab ? tab : item;
    });
    localStorage.setItem("posTab", JSON.stringify(state.tabs));
  },
  setTransportFee(state, _data) {
    let tab = state.tabs.find((tab) => tab.id == state.currentTab);
    if (typeof tab == "undefined") return false;
    tab.info.transportFee = _data;
    state.tabs = state.tabs.filter(function(item) {
      return item.id == state.currentTab ? tab : item;
    });
    localStorage.setItem("posTab", JSON.stringify(state.tabs));
  },
  setCustomer(state, _data) {
    let tab = state.tabs.find((tab) => tab.id == state.currentTab);
    if (typeof tab == "undefined") return false;
    tab.info.customer = _data;
    state.tabs = state.tabs.filter(function(item) {
      return item.id == state.currentTab ? tab : item;
    });
    return recalcData(state);
  },
  setTabPrint(state, _data) {
    let tab = state.tabs.find((tab) => tab.id == state.currentTab);
    if (typeof tab == "undefined") return false;
    tab.print = _data;
    state.tabs = state.tabs.filter(function(item) {
      return item.id == state.currentTab ? tab : item;
    });
    localStorage.setItem("posTab", JSON.stringify(state.tabs));
  },
  setSearchText(state, _data) {
    let tab = state.tabs.find((tab) => tab.id == state.currentTab);
    if (typeof tab == "undefined") return false;
    tab.search = _data;
    state.tabs = state.tabs.filter(function(item) {
      return item.id == state.currentTab ? tab : item;
    });
    console.log(state.tabs);
    //localStorage.setItem('posTab', JSON.stringify(state.tabs));
  },
  setTabLoading(state, _data) {
    let tab = state.tabs.find((tab) => tab.id == state.currentTab);
    if (typeof tab == "undefined") return false;
    tab.loading = _data;
    state.tabs = state.tabs.filter(function(item) {
      return item.id == state.currentTab ? tab : item;
    });
    localStorage.setItem("posTab", JSON.stringify(state.tabs));
  },
  setTabPayment(state, _data) {
    let tab = state.tabs.find((tab) => tab.id == state.currentTab);
    if (typeof tab == "undefined") return false;
    tab.info.payment = _data;
    state.tabs = state.tabs.filter(function(item) {
      return item.id == state.currentTab ? tab : item;
    });
    return recalcData(state);
  },
  setPaymentMethodList(state, _data) {
    state.paymentMethodList = _data;
  },
  updateProductDiscount(state, _data) {
    let tab = state.tabs.find((tab) => tab.id == state.currentTab);
    if (typeof tab == "undefined") return false;
    tab.products = tab.products.filter(function(prod) {
      if (state.productSelected.serials.join(",") == prod.serials.join(",")) {
        prod.discount = _data;
      }
      return prod;
    });
    state.tabs = state.tabs.filter(function(item) {
      if (item.id == state.currentTab) {
        item = tab;
      }
      return item;
    });
    recalcData(state);
  },
  expandProduct(state, data) {
    let tab = state.tabs.find((tab) => tab.id == state.currentTab);
    if (typeof tab == "undefined") return false;
    let products = [];
    for (const item of tab.products) {
      if (item.id == data.id) {
        for (const serial of data.serials) {
          let new_item = JSON.parse(JSON.stringify(item));
          new_item.serials = [serial];
          new_item.amount = 1;
          products.push(new_item);
        }
      } else {
        products.push(item);
      }
    }
    state.tabs = state.tabs.filter(function(item) {
      if (item.id == state.currentTab) {
        item.products = products;
      }
      return item;
    });
    recalcData(state);
  },
};
export const getters = {
  currentUser(state) {
    return state.currentUser;
  },
  search(state) {
    let tab = state.tabs.find((tab) => tab.id == state.currentTab);
    if (typeof tab == "undefined") return "";
    return tab.search;
  },
  orderNote(state) {
    let tab = state.tabs.find((tab) => tab.id == state.currentTab);
    if (typeof tab == "undefined") return "";
    return tab.note;
  },
  totalPayment(state) {
    let tab = state.tabs.find((tab) => tab.id == state.currentTab);
    if (typeof tab == "undefined") return false;
    return calcTotalPayment(tab);
  },
  totalEbill(state) {
    let tab = state.tabs.find((tab) => tab.id == state.currentTab);
    var totalEbill = 0;
    if (typeof tab != "undefined") {
      for (const item of tab.ebill) {
        totalEbill += parseInt(item.value);
      }
    }
    return totalEbill;
  },
  paymentMethodList(state) {
    return state.paymentMethodList;
  },
  paymentList(state) {
    let tab = state.tabs.find((tab) => tab.id == state.currentTab);
    if (typeof tab == "undefined") return false;
    return tab.info.payment;
  },
  tabs(state) {
    return state.tabs;
  },
  cashier(state) {
    return state.cashier;
  },
  sessionID(state) {
    return state.sessionID;
  },
  productSelected(state) {
    return state.productSelected;
  },
  posID(state) {
    return state.posID;
  },
  voucher(state) {
    let tab = state.tabs.find((tab) => tab.id == state.currentTab);
    if (typeof tab == "undefined") return false;
    return JSON.parse(JSON.stringify(tab.info.voucher));
  },
  customer(state) {
    let tab = state.tabs.find((tab) => tab.id == state.currentTab);
    if (typeof tab == "undefined") return false;
    return tab.info.customer;
  },
  province(state) {
    return state.provinceList;
  },
  district(state) {
    return state.districtList;
  },
  noti(state) {
    return state.noti;
  },
  currentTab(state) {
    let data = state.tabs.find((tab) => tab.id == state.currentTab);
    if (typeof data == "undefined") return { id: 0 };
    return data;
  },
};

export const actions = {
  createNewData({ state, commit, dispatch, getters }) {
    let tabs = state.tabs;
    if (tabs.length < 1) {
      commit("addNewTab", null);
    }
    if (state.currentTab < 1) {
      commit("selectFirstTab", null);
    }
    let nextTab = 1;
    for (const tab of tabs) {
      nextTab = nextTab < tab.id ? tab.id : nextTab;
    }
    commit("setNextTab", nextTab);
  },
  setDistrictProvince({ state, commit, dispatch, getters }, _data) {
    commit("setDistrictProvince", _data);
  },
  addNewTab({ state, commit, dispatch, getters }) {
    commit("addNewTab", null);
  },
  activeTab({ state, commit, dispatch, getters }, _id) {
    commit("activeTab", _id);
  },
  removeTab({ state, commit, dispatch, getters }, _id) {
    commit("removeTab", _id);
  },
  setSession({ state, commit, dispatch, getters }, _id) {
    commit("setSession", _id);
  },
  setPosID({ state, commit, dispatch, getters }, _id) {
    commit("setPosID", _id);
  },
  setNoti({ state, commit }, _data) {
    let _type =
      typeof _data.type == "undefined" || _data.type == "error"
        ? "danger"
        : _data.type;
    let id = state.noti.length > 0
      ? state.noti[state.noti.length - 1].id + 1
      : 1;
    commit("setNoti", { id, text: _data.text, type: _type });
    setTimeout(() => {
      commit("removeNoti", id);
    }, 5200);
  },
  resetTab({ state, commit, dispatch, getters }) {
    commit("resetTab");
  },
  recalcData({ state, commit, dispatch, getters }) {
    commit("recalcData");
  },
  addProduct({ state, commit, dispatch, getters }, _data) {
    commit("addProduct", _data);
  },
  removeProduct({ state, commit, dispatch, getters }, _data) {
    commit("removeProduct", _data);
  },
  addEbill({ state, commit, dispatch, getters }, _data) {
    commit("addEbill", _data);
  },
  removeEbill({ state, commit, dispatch, getters }, _data) {
    commit("removeEbill", _data);
  },
  expandProduct({ state, commit, dispatch, getters }, _data) {
    commit("expandProduct", _data);
  },
  setProductSelected({ state, commit, dispatch, getters }, _data) {
    commit("setProductSelected", JSON.parse(JSON.stringify(_data)));
  },
  updateProductDiscount({ state, commit, dispatch, getters }, _data) {
    commit("updateProductDiscount", _data);
  },
  setVoucher({ state, commit, dispatch, getters }, _data) {
    commit("setVoucher", JSON.parse(JSON.stringify(_data)));
  },
  setTransportFee({ state, commit, dispatch, getters }, _data) {
    commit("setTransportFee", JSON.parse(JSON.stringify(_data)));
  },
  removeDiscountCustomer({ state, commit, dispatch, getters }) {
    commit("removeDiscountCustomer");
  },
  removeDiscountVoucher({ state, commit, dispatch, getters }) {
    commit("removeDiscountVoucher");
  },
  setDiscountOther({ state, commit, dispatch, getters }, _data) {
    commit("setDiscountOther", _data);
  },
  setCashier({ state, commit, dispatch, getters }, _data) {
    commit("setCashier", _data);
  },
  setCashierSelected({ state, commit, dispatch, getters }, _data) {
    commit("setCashierSelected", _data);
  },
  setOrderNote({ state, commit, dispatch, getters }, _data) {
    commit("setOrderNote", _data);
  },
  setCustomer({ state, commit, dispatch, getters }, _data) {
    commit("setCustomer", JSON.parse(JSON.stringify(_data)));
  },
  setPaymentMethodList({ state, commit, dispatch, getters }, _data) {
    commit("setPaymentMethodList", JSON.parse(JSON.stringify(_data)));
  },
  setTabPayment({ state, commit, dispatch, getters }, _data) {
    commit("setTabPayment", JSON.parse(JSON.stringify(_data)));
  },
  setTabLoading({ state, commit, dispatch, getters }, _data) {
    commit("setTabLoading", _data);
  },
  setTabPrint({ state, commit, dispatch, getters }, _data) {
    commit("setTabPrint", _data);
  },
  setSearchText({ state, commit, dispatch, getters }, _data) {
    commit("setSearchText", _data);
  },
  removeAllTab({ state, commit, dispatch, getters }, _data) {
    commit("removeAllTab", _data);
  },
};
